export default __webpack_public_path__ + "static/link_placeholder-809c190275e886cfb0f8c681f65cad38.png";